import React from 'react';

const UNASSIGNED = '#9CA3AF';

/**
 * Inline staff toggle chips — no dropdown.
 * All staff are visible at once; click to select/deselect.
 * `value` is an array of GroupManagers ids.
 */
const AssigneePicker = ({ staff, value, onChange }) => {
  const selectedIds = (value || []).map(String);

  const toggle = (id) => {
    const sid = String(id);
    const next = selectedIds.includes(sid)
      ? selectedIds.filter((x) => x !== sid)
      : [...selectedIds, sid];
    onChange(next.map(Number));
  };

  return (
    <div className="mt-1 flex flex-wrap gap-2">
      {staff.map((s) => {
        const on    = selectedIds.includes(String(s.Id));
        const color = s.task_color || UNASSIGNED;
        return (
          <button
            key={s.Id}
            type="button"
            onClick={() => toggle(s.Id)}
            className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs font-semibold border transition-all"
            style={on ? {
              backgroundColor: `${color}22`,
              borderColor:     color,
              color:           color,
            } : {
              backgroundColor: '#f9fafb',
              borderColor:     '#e5e7eb',
              color:           '#6b7280',
            }}
          >
            <span
              className="w-2 h-2 rounded-full flex-shrink-0"
              style={{ backgroundColor: on ? color : '#d1d5db' }}
            />
            {s.Name}
          </button>
        );
      })}
    </div>
  );
};

export default AssigneePicker;
